<template>
  <v-navigation-drawer v-bind="$attrs" v-on="$listeners" :value="value" @input="onInput">
    <slot></slot>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'navigation-drawer-scroll-lock',

  props: [ 'value' ],

  created() {
    this.$set(this.global.scrollLock, this._uid, Boolean(this.value));
  },

  destroyed() {
    this.$delete(this.global.scrollLock, this._uid);
  },

  methods: {
    onInput(v) {
      this.$set(this.global.scrollLock, this._uid, v);
      this.$emit('input', v);
    }
  }
}
</script>
